module.exports = __webpack_public_path__ + "img/中国企业联合会@2x.3086914d.png";